module.exports = __webpack_public_path__ + "media/s03_retinol.7cdddd60.mp4";